import { MuiIcon } from '../shared/icons';
import React from 'react';

export const YesNoIcon = ({ value }: { value: boolean }) => {
  return value ? <MuiIcon.CheckCircle color="primary" /> : <MuiIcon.Cancel color="error" />;
};
